import React from 'react'
// libs
import { useRouter } from 'hooks/useRouter'
// components
import { Button, BUTTON_LAYOUTS, CREATE_BUTTON_STYLE } from 'components/UI'

const CreateAccountButton = () => {
  const router = useRouter()

  const onButtonClick = () => router.push('/settings/accounts/new')

  return (
    <Button
      onClick={onButtonClick}
      style={CREATE_BUTTON_STYLE}
      layout={BUTTON_LAYOUTS.PURPLE}
    >
      Create Account
    </Button>
  )
}

export default CreateAccountButton
